/* =========================================================
   LUX REVEAL — Global Fade-In Only (IntersectionObserver)
   Targets: .lux-reveal
   Optional delay via CSS var: --lux-delay
========================================================= */

(() => {
  const SELECTOR = '.lux-reveal';
  const ACTIVE_CLASS = 'is-in';

  const revealAll = () => {
    document.querySelectorAll(SELECTOR).forEach(el => el.classList.add(ACTIVE_CLASS));
  };

  // Safety: if IO not supported
  if (!('IntersectionObserver' in window)) {
    revealAll();
    return;
  }

  const io = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add(ACTIVE_CLASS);
      io.unobserve(entry.target);
    });
  }, {
    root: null,
    threshold: 0.12,
    rootMargin: '0px 0px -10% 0px'
  });

  const observe = () => {
    document.querySelectorAll(SELECTOR).forEach(el => {
      if (el.classList.contains(ACTIVE_CLASS)) return;
      io.observe(el);
    });
  };

  // Initial
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observe, { once: true });
  } else {
    observe();
  }

  // Theme editor / dynamic section loads (Shopify)
  document.addEventListener('shopify:section:load', observe);
  document.addEventListener('shopify:section:reorder', observe);
})();